import Config from 'config';
import AbstractService from './AbstractService';

export default class ProfileService extends AbstractService {
	static getProfile() {
		return AbstractService.get(Config.endpoints.profile);
	}
	static postProfile(profile) {
		return AbstractService.post(Config.endpoints.profile, profile);
	}
	static startMergeEmail(email) {
		return AbstractService.get(
			`${Config.endpoints.profileMerge}/${email}`,
			{ dtw: false }
		);
	}
	static postMergeEmail(token) {
		return AbstractService.post(
			`${Config.endpoints.profileMerge}/${token}`,
			{ dtw: false }
		);
	}
	static startSplitEmail(email) {
		return AbstractService.get(
			`${Config.endpoints.profileSplit}/${email}`,
			{ dtw: false }
		);
	}
	static postSplitEmail(token) {
		return AbstractService.post(
			`${Config.endpoints.profileSplit}/${token}`,
			{ dtw: false }
		);
	}
}
